import { Box } from "@mui/material";
import React from "react";
import { Radar } from "react-chartjs-2";
export default function ShootingDrillChart(props) {
    return (
         <Box sx={{ maxWidth: "400px", margin: "40px auto 0" }}>
                  <Radar
                    data={{
                      labels: props.labels,
                      datasets: [
                        {
                          label:props.label,
                          data: props.chartData,
                          fill: true,
                          backgroundColor: "rgba(255,255,0,0.1)",
                          pointBackgroundColor: "#f06626",
                          borderColor: "#f06626",
                          borderWidth: 3,
                        },
                      ],
                    }}
                    options={{
                      responsive: true,
                      scales: {
                        r: {
                          min: 0,
                          max: 100,
                          ticks: {
                            color: "#000",
                          },
                          angleLines: {
                            color: "#96baf2",
                            lineWidth: 2,
                          },
                          grid: {
                            color: "#96baf2",
                            lineWidth: 2,
                          },
                          pointLabels: {
                            color: "#000",
                          },
                        },
                      },
                      plugins: {
                        legend: {
                          onClick: null,
                          labels: {
                            color: "#000",
                            font: { size: 14 },
                          },
                        },
                        tooltip: {
                          callbacks: {
                            title: (context) => {
                              let title = "";
                              context.forEach((elem, i) => {
                                if (i + 1 === context.length) {
                                  title += elem.label;
                                } else {
                                  title += elem.label + ", ";
                                }
                              });
                              return title;
                            },
                          },
                        },
                      },
                    }}
                  />
                </Box>
    );
  }